import { jsx, css } from '@emotion/core';
import LectureComponentProvider, { useLectureComponentContext } from 'components/lecture-component-provider';
import t from 'react-translate';
import ActivityStatus from 'shared/components/activity/activity-status';
import ActivityTitle from 'shared/components/activity/activity-title';
import { ActivityProgress } from 'redux/schemas/models/activity';
import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import React from 'react';
import { LectureComponentProps, LecturePageMode } from '..';
import PollHeaderPointsConfiguration from './poll-header-points-configuration';
import PollOptions from './poll-options';
import PollQuestion from './poll-question';
import { useGetPollLectureComponent, usePollEditDropdown, useVotesPushNotificationSubscriber } from './poll-utils';
import PollTitle from './poll-title';
import PollDeadline from './poll-deadline';
import { useSelector } from 'react-redux';

/* @ngInject */
export default function PollLectureComponentContextWrapper(props: LectureComponentProps) {
  const currentCatalogId = useSelector(state => state.app.currentCatalogId);
  const isEdit = props.mode === LecturePageMode.EDIT;
  return (
    <LectureComponentProvider
      catalogId={currentCatalogId}
      lectureComponentId={props.lectureComponent.id}
      lecturePageId={props.currentLecture.id}
      isEdit={isEdit}
      angularComponent={props.angularComponent}
    >
      <PollLectureComponent {...props} />
    </LectureComponentProvider>
  );
}

function PollLectureComponent(props: LectureComponentProps) {
  const lectureComponent = useGetPollLectureComponent();
  const currentCatalogId = useSelector(state => state.app.currentCatalogId);
  const { isEdit } = useLectureComponentContext();

  // Edit dropdown poll options
  usePollEditDropdown(lectureComponent);
  // subscribe for new votes
  useVotesPushNotificationSubscriber();

  // TODO: Update this to the new normalized format
  const [questionId] = lectureComponent.poll.questionIds;

  return (
    <div id={`lecture-component-${props.lectureComponent.id}`}>
      <div css={headerContainerStyle}>
        <div className='activity-status'>
          <ActivityStatus icon='polls' status={lectureComponent.poll.progress} />
        </div>
        <ActivityTitle
          status={lectureComponent.poll.progress}
          statusesTexts={{
            not_started: t.LECTURE_PAGES.COMPONENTS.POLLS.HEADER_TAKE_TITLE(),
          }}
        />

        <PollTitle lectureComponent={lectureComponent} />

        {lectureComponent.poll.pointsConfigurationId && (
          <PollHeaderPointsConfiguration
            pointsConfigurationId={lectureComponent.poll.pointsConfigurationId}
            status={isEdit ? null : lectureComponent.poll.progress}
          />
        )}

        {/* deadline */}
        <PollDeadline />
      </div>

      <PollQuestion pollQuestionId={questionId} />

      <PollOptions pollQuestionId={questionId} catalogId={currentCatalogId} pollId={lectureComponent.poll.id} />
    </div>
  );
}

const headerContainerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${standardSpacing}px;

  .activity-status {
    margin-bottom: ${halfSpacing}px;
  }
  .title-input-wrapper {
    align-self: stretch;
  }
`;
